export const UPDATE_MENU = "UPDATE_MENU";

export const updateMenu = (value) => ({
  type: UPDATE_MENU,
  value,
});
